module.exports = __webpack_public_path__ + "static/50-beaches-fb6ba34d77b5e12a4dcbe1a283177c50.mp4";